import { Cluster } from 'types/cluster';

import { Filters } from './_components/Filters';

import { WorkloadsTable } from './_components/WorkloadsTable';
import { criteria } from './searchCriteria';
import { NODE_WORKLOADS_TABLE_URL_KEY } from '../../../_constants/table-url-keys';
import { WorkloadBaseRunningInNode } from '../../../types';
import { SearchProvider } from '@cast/shared-search-ui';

import { Box, Stack } from '@cast/design-system';

type Props = {
  workloads?: WorkloadBaseRunningInNode[];
  isLoading: boolean;
  clusterId: Cluster['id'];
  /**
   * When true (default), table fills the parent — for full-height tab layouts.
   * Set false when embedded in a card/overview (no fixed parent height) so rows render.
   */
  fillParentHeight?: boolean;
};

export const WorkloadsTabContent = ({
  workloads,
  isLoading,
  clusterId,
  fillParentHeight = true,
}: Props) => {
  const isCardEmbed = !fillParentHeight;

  return (
    <SearchProvider<WorkloadBaseRunningInNode>
      criteria={criteria}
      data={workloads}
      isLoading={isLoading}
      urlKey={NODE_WORKLOADS_TABLE_URL_KEY}
    >
      <Stack
        gap={12}
        flexGrow={fillParentHeight ? 1 : undefined}
        sx={{ minWidth: 0, width: '100%' }}
      >
        <Box px={isCardEmbed ? 16 : undefined} pt={isCardEmbed ? 4 : undefined}>
          <Filters />
        </Box>
        <Box
          height={fillParentHeight ? '100%' : undefined}
          sx={{ minWidth: 0, width: '100%', overflowX: 'auto' }}
        >
          <WorkloadsTable
            clusterId={clusterId}
            fillParentHeight={fillParentHeight}
          />
        </Box>
      </Stack>
    </SearchProvider>
  );
};
